import api from "../../../../lib/API";

export const fetchTeam = async () => {
  const res = await api.get('/teams?limit=1000');
  return res.data?.data || res.data || [];
};
